import getPasswordService from '../services/components/get_password.jsx'


const getState = (passwordState) => ({ type: "GET_PASSWORD", passwordState })


export const getPasswordAction = (userid) => dispatch => {
    let state = [];

    getPasswordService((data, msg) => {

        if (msg === "success") {
            state = {
                status: 200,
                body: data
            }
            localStorage.setItem("passwordState", JSON.stringify(state))
        } else {
            state = data
        }
        dispatch(getState(state))
    },userid)
} 


// WEBPACK FOOTER //
// ./src/actions/getPasswordaction.jsx